/**
 * Created by Josef Jurca on 24/04/17.
 */

// Action types
const ActionTypes = {
        SET_REMINDER_STATUS: 'SET_REMINDER_STATUS',
        SET_REMINDER_DATA: 'SET_REMINDER_DATA',
        SET_REMINDER_ERROR: 'SET_REMINDER_ERROR'
    },

    // Status values
    ReminderStatus = {
        INITIAL: 'initial',
        REQUEST_SUCCESS: 'request-success',
        REQUEST_FAILURE: 'request-failure'
    };

/**
 * Set data action.
 *
 * @param {Function} setReminderHandler - Set reminder handler button handler.
 * @param {Function} cancelHandler - Cancel button handler.
 * @returns {Object} Action type and the new status.
 */
function setHandlers (setReminderHandler, cancelHandler) {
    return {
        type: ActionTypes.SET_REMINDER_DATA,
        setReminderHandler,
        cancelHandler
    };
}

/**
 * Set status action.
 *
 * @param {string} status - New status of the component.
 * @returns {Object} Action type and the new status.
 */
function setStatus (status) {

    return {
        type: ActionTypes.SET_REMINDER_STATUS,
        status
    };
}

/**
 * Set error action.
 *
 * @param {Object} error - Error object with reason message.
 * @returns {Object} Action type and error object.
 */
function setError (error) {

    return {
        type: ActionTypes.SET_REMINDER_ERROR,
        error
    };
}

// Exposed elements of the actions file.
export {
    ActionTypes,
    ReminderStatus,
    setHandlers,
    setStatus,
    setError
};


// WEBPACK FOOTER //
// ./src/js/store/actions/modals/setreminder.js